import IFrameAddressFields from './IFrameAddressFields'

export default IFrameAddressFields
